import { FunctionComponent } from 'react';
import styles from './Dashboard.module.scss';
import {PowerBIReport} from "../../components/common/powerbi-report/powerbi-report";
import {PowerBIReportsType} from "../../services/api/powerbi-service";

const Dashboard: FunctionComponent = () => {
  return (
    <div className={'page ' + styles.page}>
        <div className={styles.powerbiContainer}>
            <PowerBIReport
                isDashboard={false}
                reportType={PowerBIReportsType.CustomersDashboard}
            />
        </div>
    </div>
  );
};

export default Dashboard;
